<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-container grid-list-sm class="pa-4">
          <v-layout row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-select
                :items="inventoriesList"
                label="Select inventories"
                multiple
                v-model="selectedInventories"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import inventoriesAPI from '@/api/resources/inventories'
  import resourcesMixin from '@/mixins/Resources'

  export default {
    mixin: [ resourcesMixin ],
    data () {
      return {
        resources: 'inventories',
        dialog: false,
        inventoriesList: [],
        selectedInventories: []
      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    methods: {
      saveNew () {
        casesAPI.attachInventoriesToCase(this.casesid, this.selectedInventories).then(result => {
          this.$emit('resource-attached')

          this.dialog = false
        })
      },
      loadListing () {
        inventoriesAPI.loadInventories().then(result => {
          this.inventoriesList = result
          this.selectedInventories = []

          casesAPI.getLinkedInventories(this.casesid).then(result => {
            result.forEach(item => {
              this.selectedInventories.push(item.id)
            })
          }, () => {})
        })
      }
    },
    created () {
      this.loadListing()
    }
  }
</script>



// WEBPACK FOOTER //
// AttachInventoriesToCaseButton.vue?7eea4094